import React from 'react';
import { Globe, Award, Shield, Users } from 'lucide-react';

export default function AboutSection() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 space-y-10">
      
      {/* Title Header */}
      <div className="text-center space-y-3 border-b border-gray-200 pb-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-50 text-[#8B0000] border border-red-200 text-xs font-semibold uppercase">
          <Globe className="w-3.5 h-3.5" />
          About Us 關於我們
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#8B0000] font-serif">
          美國媽祖基金會簡介
        </h1>
        <p className="text-gray-500 font-mono text-sm">
          American Mazu Foundation Inc. - Founded in 2014, New York
        </p>
      </div>

      {/* Main Content Box (Chinese) */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-6">
        <div className="flex items-center gap-3 border-b border-gray-200 pb-3">
          <Award className="w-7 h-7 text-[#8B0000]" />
          <h2 className="text-2xl font-bold text-[#8B0000] font-serif">
            基金會使命與宗旨
          </h2>
        </div>

        <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
          媽祖文化弘揚立德、行善、大愛的中華傳統美德，至今已有1055年歷史，媽祖文化已於2009年9月30日被聯合國教科文組織列為人類非物質文化遺產（信俗類）。
        </p>

        <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
          美國媽祖基金會的成立必將進一步推動這一文化遺產的傳承與發展，使媽祖文化在美國大地上扎根，增進中美兩國人民的友好交往。媽祖文化也是聯繫海峽兩岸人民的精神樞紐，對祖國的和平統一大業起到積極的推動作用。
        </p>
      </div>

      {/* Dual Language English Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        
        {/* WHO ARE WE? */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 space-y-4 shadow-sm flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2.5 rounded-lg bg-red-50 text-[#8B0000] border border-red-200">
                <Users className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-[#8B0000] font-serif">
                WHO ARE WE?
              </h3>
            </div>
            <p className="text-gray-700 text-sm leading-relaxed">
              We are a non-profit organization dedicated to spread the popularity of the Mazu culture throughout the whole world. We are faithful believers of the Mazu religion and determined to allow people in the world to learn more of the Mazu faith.
            </p>
            <p className="text-gray-700 text-sm leading-relaxed mt-3">
              The establishment of the American Mazu Foundation will seek to promote the healthy development of the cultural heritage, as well as spread and prosper its influence. Therefore, it will enhance better understanding and friendship between the United States and China.
            </p>
          </div>
          <div className="pt-4 border-t border-gray-200 text-xs text-gray-500 font-mono">
            Non-Profit Organization ‧ New York, USA
          </div>
        </div>

        {/* WHO IS MAZU? */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 space-y-4 shadow-sm flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2.5 rounded-lg bg-amber-50 text-[#B8860B] border border-amber-200">
                <Shield className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-[#8B0000] font-serif">
                WHO IS MAZU?
              </h3>
            </div>
            <p className="text-gray-700 text-sm leading-relaxed">
              Mazu is the Chinese patron goddess who was dedicated to protect those out on the seas including sailors and fisherman. The worship of Mazu began in the Song dynasty and from then on she became a household name in many regions, especially in Zhejiang, Fujian, Guangdong, Hainan, Taiwan, and many countries in Southeast Asia close to the sea. She was born in 960 AD in Putian, Fujian. She would be remembered as protector of the seas and hailed a national faith.
            </p>
            <p className="text-gray-700 text-sm leading-relaxed mt-3">
              Mazu has been widely worshiped as a goddess in China for over 1,000 years. She was known for her remarkable intelligence and abilities to predict changes in the weather for the safety of sailors, fishermen, and seafarers. The belief of the Mazu culture promotes integrity, dignity, morality, charity, empathy, and love of Traditional Chinese virtues. On September 30, 2009, the belief of Mazu was accepted as Intangible Cultural Heritage by UNESCO.
            </p>
          </div>
          <div className="pt-4 border-t border-gray-200 text-xs text-gray-500 font-mono">
            UNESCO Intangible Cultural Heritage
          </div>
        </div>

      </div>

    </div>
  );
}
